// Needs to mirror constnats in HtmlField.php
export const FieldTypes = {
    TYPE_CHECKBOX: 'checkbox',
    TYPE_CONTENT: 'content',
    TYPE_DATEPICKER: 'datepicker',
    TYPE_DROPDOWN: 'dropdown',
    TYPE_FILEUPLOAD: 'file_upload',
    TYPE_IPAD: 'ipad',
    TYPE_PRINT: 'print_only',
    TYPE_T_AND_C: 't_and_c',
    TYPE_TEXT: 'text',
    TYPE_TEXTAREA: 'textarea',
    TYPE_TIMEPICKER: 'timepicker',
    TYPE_TOPAZ: 'topaz',
}
